const accessToken = process.env.GATSBY_MAPBOX_KEY;

export const mapServices = [
  {
    name: 'OpenStreetMap',
    attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
  },
  {
    name: 'Mapbox',
    attribution:
      'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
    url: `https://api.mapbox.com/styles/v1/mrthanasis/ck8j69ed10tif1iqvn02hji9j/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoibXJ0aGFuYXNpcyIsImEiOiJjank3YjhrbHowOTNpM2RsYzZ5a2o1dnR4In0.pN2fWB1hFg8IBf1r007YdQ`
  }
];